export const bardeauTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Bardeau d\u0026rsquo;asphalte',
  hero_h1: 'Bardeau d\u0026rsquo;asphalte à Lévis : le matériau le plus populaire au Québec',
  hero_subtitle: 'Abordable, esthétique, prouvé. Découvrez les marques, prix et durée de vie avant votre soumission.',
  hero_cta: 'Demander ma soumission bardeau',
  hero_stat_1: 'Durée 20–25 ans',
  hero_stat_2: 'Installé sur 90% des maisons QC',
  hero_stat_3: 'Prix abordable',

  // Pourquoi le bardeau
  pourquoi_h2: 'Pourquoi le bardeau d\u0026rsquo;asphalte reste le choix #1 au Québec',
  pourquoi_1_title: 'ABORDABLE',
  pourquoi_1_desc: '3 à 5 fois moins cher que la tôle. Accessible pour la plupart des budgets sans compromis sur la qualité.',
  pourquoi_2_title: 'ESTHÉTIQUE',
  pourquoi_2_desc: 'Plus de 30 couleurs et textures disponibles. S\u0026rsquo;adapte à tous les styles de maison, du classique au moderne.',
  pourquoi_3_title: 'INSTALLATION RAPIDE',
  pourquoi_3_desc: 'Pose en 1 à 3 jours selon la grandeur. Aucun équipement lourd, chantier propre, peu de dérangement pour la famille.',

  // Gammes
  gammes_h2: 'Les 3 gammes de bardeau d\u0026rsquo;asphalte qu\u0026rsquo;on installe',
  gamme_1_title: 'BARDEAU STANDARD',
  gamme_1_sub: '3 pattes',
  gamme_1_duree: 'Durée : 15–20 ans',
  gamme_1_garantie: 'Garantie fabricant : 25 ans',
  gamme_1_desc: 'Format traditionnel rectangulaire. Le plus abordable. Idéal projets avec budget serré ou maisons locatives.',
  gamme_2_title: 'BARDEAU ARCHITECTURAL',
  gamme_2_sub: 'Le standard',
  gamme_2_duree: 'Durée : 25–30 ans',
  gamme_2_garantie: 'Garantie fabricant : 30–40 ans',
  gamme_2_desc: 'Le standard actuel. Plus épais, look 3D, meilleure résistance au vent. 80% de nos installations à Lévis.',
  gamme_3_title: 'BARDEAU PREMIUM',
  gamme_3_sub: 'Designer',
  gamme_3_duree: 'Durée : 30–50 ans',
  gamme_3_garantie: 'Garantie fabricant : 50 ans',
  gamme_3_desc: 'Look ardoise ou bois, double épaisseur, résistance maximale aux vents. Pour propriétaires exigeants.',

  // Marques
  marques_h2: 'Les marques de bardeau qu\u0026rsquo;on installe à Lévis',
  marque_bp_title: 'BP CANADA',
  marque_bp_desc: 'Fabriqué au Québec (Lachine). Garantie 25–50 ans selon gamme. Notre marque la plus installée. Excellent rapport qualité-prix.',
  marque_iko_title: 'IKO',
  marque_iko_desc: "Fabriqué en Ontario. Garantie 30–50 ans. Bardeau Cambridge très populaire, résistance prouvée aux vents du Saint-Laurent.",
  marque_gaf_title: 'GAF (Premium)',
  marque_gaf_desc: 'Marque américaine #1 en Amérique du Nord. Garantie 50 ans. Pour projets haut de gamme avec gamme Timberline HDZ.',

  // Couleurs
  couleurs_h2: 'Les couleurs les plus choisies à Lévis',
  couleurs_note: 'Échantillons physiques disponibles gratuitement sur demande.',

  // Prix
  prix_h2: "Prix d\u0026rsquo;une toiture en bardeau d\u0026rsquo;asphalte à Lévis 2026",
  prix_table_type: 'Type de maison',
  prix_table_price: 'Prix indicatif',
  prix_row1_type: 'Bungalow 1 200–1 500 pi² (architectural)',
  prix_row1_price: '7 000 $ – 11 000 $',
  prix_row2_type: 'Cottage 1 800–2 200 pi² (architectural)',
  prix_row2_price: '10 000 $ – 15 000 $',
  prix_row3_type: 'Maison 2 étages 2 500+ pi² (architectural)',
  prix_row3_price: '13 000 $ – 19 000 $',
  prix_row4_type: 'Surplus bardeau premium designer',
  prix_row4_price: '+20% – +35%',
  prix_note: "Prix incluent retrait ancienne toiture, membrane d'étanchéité, ventilation, solins, garantie écrite. Soumission précise après inspection.",

  // Entretien
  entretien_h2: 'Comment prolonger la durée de vie de votre bardeau',
  entretien_1: 'Inspection visuelle annuelle au printemps',
  entretien_2: 'Nettoyage gouttières 2 fois par année',
  entretien_3: 'Retrait mousse et débris d\u0026rsquo;arbres',
  entretien_4: 'Vérification solins métal après gros vents',
  entretien_5: 'Déglaçage si barrage de glace en hiver',

  // FAQ
  faq_h2: 'Questions fréquentes sur le bardeau d\u0026rsquo;asphalte',
  faq_q1: 'Combien de temps dure vraiment un bardeau d\u0026rsquo;asphalte à Lévis ?',
  faq_a1: 'Un bardeau standard de qualité dure 15 à 20 ans dans le climat de Lévis. Le bardeau architectural (gamme la plus populaire) dure 25 à 30 ans. Les facteurs clés sont : la qualité de la membrane d\u0026rsquo;étanchéité sous le bardeau, la ventilation du toit (qui élimine l\u0026rsquo;humidité), et la qualité de l\u0026rsquo;installation. Un bardeau mal ventilé ou posé sans membrane sous-jacente peut détériorer en 10 ans.',
  faq_q2: 'Peut-on poser un nouveau bardeau par-dessus l\u0026rsquo;ancien ?',
  faq_a2: 'Techniquement oui, mais ce n\u0026rsquo;est pas recommandé. Poser par-dessus empêche d\u0026rsquo;inspecter le pontage et la membrane sous-jacente. Si le bardeau inférieur est humide, ça crée un sandwich d\u0026rsquo;humidité qui abîme les deux couches. On recommande l\u0026rsquo;enlèvement complet — ça coûte un peu plus, mais ça donne accès à la structure et permet une installation conforme aux normes du RBQ.',
  faq_q3: 'Quelle est la différence entre BP, IKO et GAF ?',
  faq_a3: "BP est fabriqué à Lachine, au Québec — c'est la marque la plus installée par nos partenaires grâce à son excellent rapport qualité-prix et sa disponibilité locale. IKO fabrique en Ontario et est très populaire pour sa gamme Cambridge, connue pour sa résistance au vent. GAF est la marque américaine #1 en Amérique du Nord, avec des gammes premium comme Timberline HDZ. Les trois offrent des garanties de 25 à 50 ans. On vous conseille la marque adaptée à votre budget et à vos besoins.",
  faq_q4: 'Quelle couleur de bardeau est la plus durable ?',
  faq_a4: "Les couleurs foncées (noir, brun foncé) absorbent plus de chaleur solaire, ce qui peut accélérer légèrement le vieillissement. Les couleurs claires ou intermédiaires (gris ardoise, brun moyen, sable) tendent à durer un peu plus longtemps. Cela dit, l'impact est marginal — la qualité de l'installation et la ventilation comptent beaucoup plus que la couleur. Toutes les couleurs que nous proposons sont certifiées pour résister aux UV québécois.",
  faq_q5: 'Le bardeau résiste-t-il aux vents extrêmes ?',
  faq_a5: "Le bardeau architectural (notre gamme standard) est classé pour résister à des vents jusqu'à 180 km/h quand il est correctement installé avec des clous résistants aux vents (par opposition aux agrafes). Dans notre région du Saint-Laurent, où les vents peuvent être forts, on utilise toujours la technique des 6 clous par bardeau (au lieu des 4 minimum) et on scelle les cônes de toit. La garantie fabricant couvre aussi les dégâts de vent dans la plupart des cas.",

  // CTA Final
  cta_h2: 'Votre toiture en bardeau à Lévis commence ici',
  cta_subtitle: 'Inspection gratuite, choix de marques et couleurs, garantie écrite.',
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez votre soumission gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle en 2h ouvrables.',
  form_success: 'Soumission envoyée !',
  form_success_sub: 'On vous rappelle dans les 2 prochaines heures ouvrables. Merci de nous faire confiance.',
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_gamme_label: 'Gamme de bardeau souhaitée',
  form_gamme_select: 'Sélectionnez une gamme',
  form_message_label: 'Description du projet',
  form_message_placeholder: 'Décrivez votre maison, superficie, nombre de pans, problèmes actuels...',
  form_char_count: '/500',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default bardeauTranslations;